import { render } from "./app-depart-layout.vue?vue&type=template&id=4422dee0&scoped=true"
import script from "./app-depart-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./app-depart-layout.vue?vue&type=script&setup=true&lang=js"

import "./app-depart-layout.vue?vue&type=style&index=0&id=4422dee0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4422dee0"],['__file',"src/layouts/app-depart-layout/app-depart-layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4422dee0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4422dee0', __exports__)) {
    api.reload('4422dee0', __exports__)
  }
  
  module.hot.accept("./app-depart-layout.vue?vue&type=template&id=4422dee0&scoped=true", () => {
    api.rerender('4422dee0', render)
  })

}


export default __exports__